import Instance from "../../../../Axios";

// New Actions for the app

const GetFabricanteById = (id) => async (dispatch) => {
  await Instance()
    .get(`/energias/fabricantes/${id}`)
    .then(({ data }) => {
      dispatch({ type: "GET_FABRICANTE_BY_ID", payload: data.yData[0] });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetFabricanteById;